import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { TodoTableTodo } from "../TodoTable";

function getFulfillForColumn(): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Zu erfüllen für",
    accessorKey: "fulfillFor",
    size: 200,
    filterVariant: "multi-select"
  };
}

export { getFulfillForColumn };
